import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=07dd8b9e&scoped=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleSection.vue?vue&type=style&index=0&id=07dd8b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd8b9e",
  null
  
)

export default component.exports